import { secondAxios } from "../../../../../../api/axios";

export const get5d = async (equipId) => {
  const response = await secondAxios.get(`/cost5d/${equipId}/rev/303/pv`);
  console.log({ response });
  return response.data;
};
